import React, { HTMLProps } from "react";
import { twMerge } from "tailwind-merge";
import CardHeader from "./header";
import CardImage from "./image";
import CardContent from "./content";
import CardFooter from "./footer";
import { Element } from "../base";

interface IProps extends HTMLProps<HTMLAnchorElement> {
    className?: string;
    children: React.ReactNode;
    domRef?: any;
}

function Card(props: IProps) {
    const { className, children, ...rest } = props;
    return (
        <Element
            className={twMerge(
                "group/card",
                "bm-card",
                "relative max-w-full",
                className
            )}
            {...rest}
        >
            {children}
        </Element>
    );
}

Card.Image = CardImage;
Card.Header = CardHeader;
Card.Content = CardContent;
Card.Footer = CardFooter;

export default Card;
